var quizAnswers =  ['b', 'b', 'b', 'c', 'a', 'b', 'b', 'a', 'a', 'b', 'c', 'b', 'd', 'a', 'b', 'b', 'b', 'b', 'd', 'c' ]

var quizQuestions = [
  {
    question: "Drivers under 19 years old are forbidden from using handheld devices while driving.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>Illinois prohibits all drivers from using handheld cellphones, computers, and the like while behind the wheel</strong>. If you are over 19 years old, wireless devices are permitted.",
    correctAnswer: "b"
  },
  {
    question: "Drivers over 18 years old do not have to wear a seat belt in the back seat",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>All drivers must wear a seat belt at all times</strong>, unless a child is being secured with a proper restraint system.",
    correctAnswer: "b"
  },
  {
    question: "Around how many inches do airbags need to inflate?",
    answers: {
      a: "5 inches.",
      b: "10 inches.",
      c: "15 inches.",
      d: "20 inches."
    },
    description: "Since airbags need about <strong>10 inches</strong> to inflate, you should always leave that much space between yourself and the steering wheel. If you cannot do this while maintaining full control of your vehicle, contact a manufacturer to see what can be done to correct the problem.",
    correctAnswer: "b"
  },
  {
    question: "Unless otherwise posted, the speed limit in a town or city area is:",
    answers: {
      a: "20 mph",
      b: "25 mph",
      c: "30 mph",
      d: "35 mph"
    },
    description: "The Illinois Department of Transportation has a set maximum speed limit for certain types of roads. Though local governments can change the speed limit in an area, the generally accepted speed limit for town or city roads in Illinois is <strong>30 mph</strong>.",
    correctAnswer: "c"
  },
  {
    question: "When driving in a funeral procession, drivers must turn on their headlights and hazard lights.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>If you are part of a funeral procession, you must keep your headlights and hazard lights on</strong>. If you see a funeral procession, know that they have the right-of-way. Attempting to pass the procession or any vehicle in it can get you cited for reckless driving.",
    correctAnswer: "a"
  },
  {
    question: "If two cars come to a stop at the same intersection at the same time, the driver to the right should yield to the driver to the left.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "The driver to the left should always <strong>yield to the driver to the right</strong>.",
    correctAnswer: "b"
  },
  {
    question: "If you are attempting to pass a driver, you must return to your lane within how many feet of any oncoming vehicles?",
    answers: {
      a: "100 feet",
      b: "200 feet",
      c: "300 feet",
      d: "400 feet"
    },
    description: "If you are trying to pass another driver, make sure you can return to the right side of the road while still leaving at least <strong>200 feet</strong> between yourself and any approaching cars.",
    correctAnswer: "b"
  },
  {
    question: "You cannot pass in a construction zone, even if it has striped lines.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Passing in a construction zone is <strong>always illegal</strong> in Illinois.",
    correctAnswer: "a"
  },
  {
    question: "To hand signal a left turn, you must stick your arm straight out.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>To signal left, you stick your arm straight out</strong>; to signal right, you stick your arm up, keeping your elbow straight; to signal a stop, you point your arm down.",
    correctAnswer: "a"
  },
  {
    question: "You must drive in a clockwise direction in a roundabout.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Roundabouts always travel in a <strong>counter-clockwise direction</strong>.",
    correctAnswer: "b"
  },
  {
    question: "If you fail to stop for a school bus and are convicted, how long will your driver's license be suspended?",
    answers: {
      a: "One month",
      b: "Two months",
      c: "Three months",
      d: "Four months"
    },
    description: "Failing to stop for a school bus can result in a <strong>three-month license suspension</strong>.",
    correctAnswer: "c"
  },
  {
    question: "If you are parked uphill, your front wheels should always be turned to the right.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "If there is a curb on the road, your wheels should be turned to the left. Otherwise, you should turn them to the right when parking uphill.",
    correctAnswer: "b"
  },
  {
    question: "Where is it illegal to park?",
    answers: {
      a: "Within 20 feet of a fire station",
      b: "Within 15 feet of a fire hydrant",
      c: "Within 50 feet of a railroad crossing",
      d: "All of the above"
    },
    description: "It is illegal to park within 20 feet of fire station, within 15 feet of a fire hydrant and within 50 feet of a railroad crossing.",
    correctAnswer: "d"
  },
  {
    question: "Over 50% of motorcycle collisions occur at intersections.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Intersections are particularly dangerous for motorcyclists, <strong>where over 50% of motorcycle crashes occur</strong>. For this reason, both motorists and motorcyclists should be very cautious when driving through an intersection.",
    correctAnswer: "a"
  },
  {
    question: "When you are passing a bicyclist, how many feet should you leave between yourself and the bicycle before you pass and before you pull back into your lane?",
    answers: {
      a: "Two feet",
      b: "Three feet",
      c: "Four feet",
      d: "Five feet"
    },
    description: "If you are going to pass a bicycle, make sure you pull out when you still have at least <strong>three feet</strong> between you and the bicycle. Do not reenter your lane until you are at least three feet ahead of the bicycle. You can, of course, leave more space, but three feet is the state requirement.",
    correctAnswer: "b"
  },
  {
    question: "It is legal to ride horseback on all roads in Illinois.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "While it is legal to ride a horse on most roads in Illinois, <strong>horseback riding is forbidden on limited access highways and expressways</strong>.",
    correctAnswer: "b"
  },
  {
    question: "You cannot be convicted of drunk driving if your BAC is below .08%.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Even if your BAC is below .08%, you can still be charged with Driving Under the Influence (DUI) if the officer has sufficient evidence that your ability to drive is impaired.",
    correctAnswer: "b"
  },
  {
    question: "For a first-time DUI conviction, how long will your license be revoked for?",
    answers: {
      a: "6 months",
      b: "1 year",
      c: "18 months",
      d: "5 years"
    },
    description: "Your license is revoked for <strong>1 year</strong> after your first conviction, 5 years after a second conviction, 10 years after a third conviction and for life after a fourth conviction.",
    correctAnswer: "b"
  },
  {
    question: "What kind of information do diamond-shaped signs usually provide drivers?",
    answers: {
      a: "Directional information",
      b: "School zone",
      c: "Recreational information",
      d: "Warnings"
    },
    description: "A sign shaped like a diamond will provide drivers with some kind of <strong>warning</strong>, usually of approaching hazards and road conditions.",
    correctAnswer: "d"
  },
  {
    question: "A pennant-shaped sign is usually used for:",
    answers: {
      a: "General regulatory signs",
      b: "School crossings signs",
      c: "Advanced warning for no pass zones",
      d: "To warn of possible hazards on or near the road"
    },
    description: "Usually a pennant-shaped sign will indicate to motorists that a <strong>no pass zone</strong> is up ahead. Regulatory signs are vertical rectangles; pentagons are for school crossings and school advance signs; and diamond-shaped signs warn motorists of possible hazards.",
    correctAnswer: "c"
  }
];
